import { EventEmitter } from '@angular/core';
var FilterHeaderComponent = (function () {
    function FilterHeaderComponent() {
        this.search = new EventEmitter();
        this.clear = new EventEmitter();
        this.excel = new EventEmitter();
    }
    FilterHeaderComponent.prototype.ngOnInit = function () {
    };
    return FilterHeaderComponent;
}());
export { FilterHeaderComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/core/filter-header/filter-header.component.ts.pre-build-optimizer.js